import { Flex, Text } from 'pcln-design-system'
import styled, { keyframes } from 'styled-components'

const rotateText = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  51% { opacity: 0; }
  100% { opacity: 0; }
`

export const FlexWrapper = styled(Flex)`
  height: 100%;
  position: relative;
`

export const PrimaryBanner = styled(Text)`
  animation: ${rotateText} 8s infinite;
`

export const SecondaryBanner = styled(Flex)`
  animation: ${rotateText} 8s 4s infinite;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
`
